var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9996 20.4545V30.1363H38.4541C37.8633 33.2499 36.0904 35.8864 33.4313 37.6591L41.5449 43.9546C46.2722 39.5911 48.9995 33.182 48.9995 25.5684C48.9995 23.7957 48.8404 22.091 48.5449 20.4547L24.9996 20.4545Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9889 29.7584L9.15902 31.1592L2.68164 36.2045C6.79527 44.3635 15.2265 50 24.9991 50C31.7489 50 37.408 47.7727 41.5444 43.9546L33.4308 37.6591C31.2035 39.1591 28.3626 40.0683 24.9991 40.0683C18.4991 40.0683 12.9766 35.6819 10.9992 29.7728L10.9889 29.7584Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68162 13.7955C0.977171 17.159 0 20.9545 0 24.9999C0 29.0452 0.977171 32.8408 2.68162 36.2043C2.68162 36.2268 10.9999 29.7497 10.9999 29.7497C10.4999 28.2497 10.2044 26.6589 10.2044 24.9996C10.2044 23.3403 10.4999 21.7495 10.9999 20.2495L2.68162 13.7955Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9996 9.95454C28.6815 9.95454 31.9542 11.2272 34.5678 13.6818L41.7268 6.52281C37.3859 2.47743 31.7497 0 24.9996 0C15.227 0 6.79527 5.61363 2.68164 13.7955L10.9997 20.25C12.9769 14.3409 18.4997 9.95454 24.9996 9.95454Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.67f63d3fe09f057baff71b9bd0468320.svg";
export { ForwardRef as ReactComponent };